import api from "!../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-10.use[1]!../postcss-loader/dist/cjs.js??clonedRuleSet-10.use[2]!./jquery-jvectormap.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};